/**
 * Ops simulation T03 — how a return's status reads in POS, and the browser
 * event the realtime layer raises when a return changes on the server.
 */
import type { BillReturnStatus } from '@/services/billing.service';

export const RETURN_STATUS_META: Record<BillReturnStatus, { label: string; className: string }> = {
  DRAFT: {
    label: 'Draft',
    className: 'bg-neutral-100 text-neutral-700 dark:bg-neutral-700 dark:text-neutral-200',
  },
  WAITING_APPROVAL: {
    label: 'Waiting for approval',
    className: 'bg-warning-100 text-warning-700 dark:bg-warning-900/30 dark:text-warning-300',
  },
  COMPLETED: {
    label: 'Completed',
    className: 'bg-success-100 text-success-700 dark:bg-success-900/30 dark:text-success-300',
  },
  REJECTED: {
    label: 'Rejected',
    className: 'bg-danger-100 text-danger-700 dark:bg-danger-900/30 dark:text-danger-300',
  },
  CANCELLED: {
    label: 'Cancelled',
    className: 'bg-neutral-200 text-neutral-600 dark:bg-neutral-700 dark:text-neutral-300',
  },
};

/** Statuses a cashier can filter the Returns list by, in workflow order. */
export const RETURN_STATUS_FILTERS: BillReturnStatus[] = ['WAITING_APPROVAL', 'COMPLETED', 'REJECTED', 'CANCELLED'];

export function returnStatusMeta(status: string) {
  return RETURN_STATUS_META[status as BillReturnStatus] ?? { label: status, className: RETURN_STATUS_META.DRAFT.className };
}

/** Raised on `window` when a return_approval notification arrives (approved / rejected / failed). */
export const RETURN_UPDATE_EVENT = 'bbpos:return-update';

export interface ReturnUpdateDetail {
  bill_id?: string | null;
  return_id?: string | null;
  return_number?: string | null;
  status?: string | null;
  result?: string | null;
}
